module.exports = __webpack_public_path__ + "media/images/flags/32/Chad-b643ffde9aef94124980f1164f92604b.png";